import { UserDetails } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { AIR_RECEPTIONIST_MOCK_ID } from '../../constants';
import { taskCenterTrackingIds } from '../../tracking-ids';

export const generateKey = (item: UserDetails) => `searchable-${item.userId ?? ''}`;

export const itemValue = (item: UserDetails) => item.userId ?? '';

export const generateTrackingId = (item: UserDetails) => {
  if (item.userId === AIR_RECEPTIONIST_MOCK_ID) {
    return taskCenterTrackingIds.filters.airCreatedBy;
  }
  return `task-center-created-by-${item.firstName ?? ''}-${item.lastName ?? ''}-filter`;
};
